import type { FC } from "react";
import { uniqueId } from "lodash";

import DiseaseLabel from "@/components/ui/disease-label";

type PatientCardProps = {
  date: Date;
  reason: string;
  comment?: string | null;
  onClick: React.MouseEventHandler<HTMLDivElement>;
  extraFields?: Array<{
    hidden: boolean;
    fields: Array<{ label: string; value: string }>;
  }>;
};

const PatientCard: FC<PatientCardProps> = ({
  date,
  reason,
  comment,
  onClick,
  extraFields,
}) => {
  return (
    <div
      className="px-5 pt-5 pb-3 bg-white rounded-lg relative cursor-pointer"
      onClick={onClick}
    >
      <div className="absolute -top-2 py-[2px] px-[6px] bg-gray-600 rounded-lg text-[10px] text-white font-medium">
        {date.toLocaleDateString()}
      </div>
      <div className="flex gap-6 overflow-x-auto">
        <div className="flex flex-col w-[176px]">
          <div className="text-xs text-gray-500">Motif</div>
          <DiseaseLabel
            customLabel={reason}
            className="text-xs font-medium w-fit"
          />
        </div>
        {comment ? (
          <>
            <div className="border border-gray-200 h-8" />
            <div className="flex flex-col">
              <div className="text-xs text-gray-500">Commentaire</div>
              <div className="text-sm text-black break-words line-clamp-1">
                {comment}
              </div>
            </div>
          </>
        ) : null}
        {extraFields
          ? extraFields
              .filter((extraField) => !extraField.hidden)
              .map((extraField) => (
                <div className="flex gap-6" key={`extra-field-${uniqueId()}`}>
                  <div className="border border-gray-200 h-8" />
                  {extraField.fields
                    .filter((field) => field.value)
                    .map((field) => (
                      <div
                        key={`extra-field-${field.label}-${uniqueId()}`}
                        className="flex flex-col"
                      >
                        <div className="text-xs text-gray-500">
                          {field.label}
                        </div>
                        <div className="text-sm text-black break-words line-clamp-1">
                          {field.value}
                        </div>
                      </div>
                    ))}
                </div>
              ))
          : null}
      </div>
    </div>
  );
};

export default PatientCard;
